import React, { useState } from 'react';
import { AppShell } from '@/components/layout/AppShell';
import { Card } from '@/components/ui/Card';
import { Calendar } from '@/components/ui/Calendar';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/Carousel';
import { Alert, AlertDescription } from '@/components/ui/Alert';
import { Info } from 'lucide-react';

export function AdditionalComponents() {
  const [calendarDate, setCalendarDate] = useState<Date | undefined>(new Date());

  return (
    <AppShell>
      <div className="p-6 space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-3xl font-semibold text-foreground mb-2">
            Additional Components
          </h1>
          <p className="text-muted-foreground">
            Advanced form inputs, data display, and specialized components
          </p>
        </div>

        <Alert>
          <Info className="h-4 w-4" />
          <AlertDescription>
            This page is being migrated to shadcn/ui components. Some components are temporarily unavailable.
          </AlertDescription>
        </Alert>

        {/* Calendar */}
        <Card className="p-6">
          <h3 className="text-xl font-semibold text-foreground mb-6">
            Calendar
          </h3>

          <div className="flex justify-center">
            <Calendar
              mode="single"
              selected={calendarDate}
              onSelect={setCalendarDate}
              className="rounded-md border"
            />
          </div>

          <p className="mt-4 text-sm text-muted-foreground text-center">
            Selected: {calendarDate?.toLocaleDateString()}
          </p>
        </Card>

        {/* Carousel */}
        <Card className="p-6">
          <h3 className="text-xl font-semibold text-foreground mb-6">
            Carousel
          </h3>

          <Carousel className="w-full max-w-xs mx-auto">
            <CarouselContent>
              {[1, 2, 3, 4, 5].map((num) => (
                <CarouselItem key={num}>
                  <div className="p-1">
                    <Card className="p-6">
                      <div className="h-48 flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 rounded-md">
                        <div className="text-center">
                          <h4 className="text-2xl font-bold text-white mb-2">
                            Slide {num}
                          </h4>
                          <p className="text-white/80">
                            This is slide number {num}
                          </p>
                        </div>
                      </div>
                    </Card>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </Card>

        {/* Coming Soon Section */}
        <Card className="p-6">
          <h3 className="text-xl font-semibold text-foreground mb-4">
            Coming Soon
          </h3>
          <p className="text-muted-foreground">
            The following components are being migrated to shadcn/ui equivalents:
          </p>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground list-disc list-inside">
            <li>Date & Time Pickers (migrating to shadcn date picker)</li>
            <li>Color Picker (evaluating shadcn alternatives)</li>
            <li>Tag Input (migrating to shadcn combobox)</li>
            <li>Code Editors (evaluating integration options)</li>
            <li>Virtual List (evaluating virtualization libraries)</li>
          </ul>
        </Card>
      </div>
    </AppShell>
  );
}
